import { render, staticRenderFns } from "./TheDocumentPackagers.vue?vue&type=template&id=a626d212&scoped=true&"
import script from "./TheDocumentPackagers.vue?vue&type=script&lang=js&"
export * from "./TheDocumentPackagers.vue?vue&type=script&lang=js&"
import style0 from "./TheDocumentPackagers.vue?vue&type=style&index=0&id=a626d212&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a626d212",
  null
  
)

export default component.exports